export enum TaskDirectionNames {
  'In' = 0,
  'Out' = 1,
}
